import React, { useContext } from 'react'
import { Nav, Navbar, Icon } from '@softwaredev_cegeka/stix-core'
import { NavLink } from 'react-router-dom'
import UserMenu from './UserMenu'
import { reverse } from 'src/routes/config'
import { UserDataContext } from 'src/components/auth/withAuth'
import { workflowWriteIsAllowed } from 'src/utils/authorization'

import logo from '../../assets/images/approval-logo.svg'
import './header.scss'

const Header = ({ stripped = false }) => {
    const context = useContext(UserDataContext)
    return (
        <Navbar
            fixed={'top'}
            sticky={'top'}
            bg={'primary'}
            variant={'dark'}
            expand={'lg'}
        >
            {!stripped ? (
                <>
                    <NavLink to={'/'} className="stix-navbar-brand">
                        <img src={logo} alt={'logo'} className={'logo'} />
                    </NavLink>
                    <Navbar.Toggle children={<Icon icon={'menu'} />} />

                    <Navbar.Collapse id={'main-nav'}>
                        <Nav>
                            {workflowWriteIsAllowed(context) ? (
                                <NavLink
                                    className={'stix-nav-link'}
                                    activeClassName="active"
                                    to={reverse('workflow')}
                                >
                                    Workflow
                                </NavLink>
                            ) : null}
                            <NavLink
                                className={'stix-nav-link'}
                                activeClassName="active"
                                to={reverse('delegation-list')}
                            >
                                Delegations
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>

                    <Navbar.Right>
                        <UserMenu />
                    </Navbar.Right>
                </>
            ) : (
                <Navbar.Brand>
                    <img src={logo} alt={'logo'} className={'logo'} />
                </Navbar.Brand>
            )}
        </Navbar>
    )
}

export default Header
